import { uniq } from 'lodash'
import { Page } from '../../../models/util.model'
import { Activity } from '../models/activity.entity'
import { ActivityListingKeys } from '../models/activity-listing.model'

/**
 * Parse activity page keys
 * @param page - the activities page
 * @returns the page listing keys
 */
export function parseActivityPageKeys(
  page: Page<Activity>,
): ActivityListingKeys {
  return page.data.reduce<ActivityListingKeys>(
    (acc, r) => parseActivityKeys(r, acc),
    {},
  )
}

/**
 * Parse activity keys
 * @param activity - the activity
 * @param keys - the keys already loaded
 * @returns the activity listing keys
 */
export function parseActivityKeys(
  activity: Activity,
  keys: ActivityListingKeys = {},
): ActivityListingKeys {
  const executionIds = uniq([
    ...(keys['executionIds'] || []),
    ...(activity.lastExecutionId ? [activity.lastExecutionId] : []),
  ])

  return {
    executionIds,
  }
}
